export default "/_next/static/chunks/fonts/din-regular-webfont-7ca96da2c928f7106e6d4495b644813f.ttf";